import { useEffect, useState, useCallback } from "react";
import {
    GetAssignFollowUpOrders,
    AssignOrders as AssignOrdersService
} from "../../services/orderService";

const AssignFollowUpOrder = () => {

    const [followUpData, setFollowUpData] = useState([]);
    const [message, setMessage] = useState("");
    const [unAssign, setUnAssign] = useState(0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [assignLoading, setAssignLoading] = useState(false);


    const fetchData = useCallback(async () => {
        try {

            setLoading(true);

            const response = await GetAssignFollowUpOrders();

            console.log("Get Assign Orders Response:", response);


            if (response?.statusCode === 200 && response?.success) {

                const data = response.data || {};

                setUnAssign(
                    data.unAssignedOrderCount ?? 0
                );

                setFollowUpData(
                    data.assignFollowUpOrderDtls ?? []
                );

                setError("");

            }
            else {

                setFollowUpData([]);
                setUnAssign(0);

                setError(
                    response?.message || "No data found"
                );
            }


        } catch (error) {

            console.error(error);

            setError(
                error?.message || "Something went wrong"
            );

        }
        finally {

            setLoading(false);

        }

    }, []);



    useEffect(() => {

        fetchData();

    }, [fetchData]);



    const handleAssignOrders = async () => {

        try {

            setAssignLoading(true);
            setMessage("");
            setError("");


            const response = await AssignOrdersService();


            console.log("Assign API Response:", response);


            if (
                response?.statusCode === 200 &&
                response?.success === true
            ) {

                setMessage(
                    response.message ||
                    "Orders assigned successfully"
                );


                // Immediately reload table
                await fetchData();


            }
            else {

                setMessage(
                    response?.message ||
                    "Assignment failed"
                );

            }


        }
        catch(error){

            console.error(error);

            setError(
                error?.message ||
                "Something went wrong"
            );

        }
        finally{

            setAssignLoading(false);

        }

    };



    return (

        <div className="container mt-4">

            <div className="card shadow">


                <div className="card-header bg-primary text-white">
                    <h4>
                        Assign FollowUp Order List
                    </h4>
                </div>



                <div className="card-body">


                    {message &&
                        <div className="alert alert-success">
                            {message}
                        </div>
                    }



                    {error &&
                        <div className="alert alert-danger">
                            {error}
                        </div>
                    }



                    <div className="d-flex justify-content-between mb-3">


                        <h5>
                            Total Records:
                            <span className="badge bg-primary ms-2">
                                {followUpData.length}
                            </span>
                        </h5>



                        <button
                            className="btn btn-success"
                            onClick={handleAssignOrders}
                            disabled={assignLoading}
                        >

                            {
                                assignLoading
                                ? "Assigning..."
                                : `${unAssign} Orders Pending`
                            }

                        </button>


                    </div>




                    {
                        loading ?

                        <h5>Loading...</h5>


                        :

                        <table className="table table-bordered">

                            <thead className="table-dark">

                                <tr>
                                    <th>#</th>
                                    <th>Team Leader</th>
                                    <th>Assign User</th>
                                    <th>Order Id</th>
                                    <th>Status</th>
                                </tr>

                            </thead>


                            <tbody>

                            {
                                followUpData.length > 0 ?

                                followUpData.map((item,index)=>(

                                    <tr key={item.id ?? index}>

                                        <td>
                                            {index+1}
                                        </td>


                                        <td>
                                            {item.teamLeader ?? "-"}
                                        </td>


                                        <td>
                                            {item.assignUser ?? "-"}
                                        </td>


                                        <td>
                                            {item.orderId ?? "-"}
                                        </td>


                                        <td>
                                            {item.isAssigned ? "Assigned" : "Unassigned"}
                                        </td>


                                    </tr>

                                ))

                                :

                                <tr>
                                    <td colSpan="5" className="text-center">
                                        No Data Found
                                    </td>
                                </tr>

                            }

                            </tbody>


                        </table>

                    }



                </div>

            </div>


        </div>

    );
};


export default AssignFollowUpOrder;